import { render, staticRenderFns } from "./ModalProduto.vue?vue&type=template&id=eb85b446&scoped=true"
import script from "./ModalProduto.vue?vue&type=script&lang=js"
export * from "./ModalProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb85b446",
  null
  
)

export default component.exports